module.exports = __webpack_public_path__ + "media/images/lp_v10_mv_title-c06bea96182ce432b61177eff9933ed5.webp";